export type PlacementType = "listing" | "commonArea"

export interface PlacementDetail {
    placement: {
        id: string
        placementType: PlacementType
    }
    listing?: {
        name: string
    }
    commonArea?: {
        name: string
    }
}

export const extractPlacementName = (p: PlacementDetail) => {
    switch (p.placement.placementType) {
        case "listing":
            return p.listing?.name ?? ""
        case "commonArea":
            return p.commonArea?.name ?? ""
    }
}
